import React from "react";
import { FaMoneyBill, FaBoxesStacked, FaGear } from "react-icons/fa6";
import banner9 from "../assets/banner9.jpg";

export default function ERPSystem() {
  const features = [
    { icon: <FaGear size={20} className="text-primary" />, text: "Custom workflows for finance, procurement, HR, and supply chain." },
    { icon: <FaMoneyBill size={20} className="text-primary" />, text: "Streamlined accounting and reporting for transparency and efficiency." },
    { icon: <FaBoxesStacked size={20} className="text-primary" />, text: "Integrated inventory and operations for better resource management." },
  ];

  return (
    <section className="MainBodySection service-detail-page">
      <div className="container service-detail-shell">
        <div className="text-center">
          <div className="section-kicker mb-3">Service Detail</div>
          <h2 className="main-section-title">Enterprise Resource Planning (ERP) System</h2>
          <p className="section-copy">
            Development and customization of ERP solutions to streamline core business processes within a unified platform.
          </p>
        </div>

        <div className="service-detail-media">
          <img src={banner9} alt="ERP System" />
        </div>

        <div className="detail-card">
          <p className="detail-summary mb-4">
            ERP systems provide centralized data and automation across key departments, improving visibility, efficiency, and decision-making.
          </p>

          <ul className="detail-feature-list mb-4">
            {features.map(item => (
              <li key={item.text} className="detail-feature-item">{item.icon}<span>{item.text}</span></li>
            ))}
          </ul>

          <ol className="detail-step-list">
            <li>Analyze existing business processes and requirements.</li>
            <li>Configure ERP modules for finance, HR, procurement, and supply chain.</li>
            <li>Test system integration and data flow accuracy.</li>
            <li>Deploy ERP platform and train staff for effective use.</li>
          </ol>
        </div>
      </div>
    </section>
  );
}